import styled from 'styled-components'

export const BowTieStyledContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    svg#bowtie-svg {
        background: ${({ theme }) => theme['gray-200']};
        cursor: move;

        #bowtie-container {
            .hazardLine {
                stroke: ${({ theme }) => theme['yellow-500']};
                stroke-width: 2px;
                stroke-dasharray: 5 5;
                opacity: 0.5;
            }

            .hazardAuxLine {
                stroke: ${({ theme }) => theme['gray-400']};
                stroke-width: 2px;
                stroke-dasharray: 5 5;
                opacity: 0.5;
            }

            text {
                fill: #fff;
            }
        }

        #bowtie-topbar {
            text {
                fill: var(--static-gray-1000);
            }
        }
    }
`

export const PdfTableContainer = styled.div`
    background: #fff;
    height: 595px;
    width: 841px;
    font-size: 10px;
    padding-top: 20px;

    .custom-list-bowtie-export-pdf {
        width: 841px;
        font-size: 8px;

        .custom-list-column-ref-list {
            font-size: 8px;
            letter-spacing: 0.5px;
        }

        .custom-list-column-threat_ids,
        .custom-list-column-threat_barrier_ids,
        .custom-list-column-consequence_id,
        .custom-list-column-consequence_barrier_ids {
            flex-wrap: wrap;
            word-wrap: break-word;
            height: max-content;
        }
    }
`
